import api from './api';

export const userService = {
  getMe: () => api.get('/users/me'),
  updateProfile: (data) => api.put('/users/me', data),
  getPublicProfile: (username) => api.get(`/users/${username}`),
  trackCategoryVisit: (category) => api.post('/users/me/category-visit', { category }),
  getTopCategories: () => api.get('/users/me/top-categories'),
};
